import { isFunction } from 'lodash';

function checkEvent(e, el, binding) {
  // https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/directives/click-outside/index.ts

  // The include element callbacks below can be expensive
  // so we should avoid calling them when we're not active.
  // Explicitly check for false to allow fallback compatibility
  // with non-toggleable components
  if (!e || checkIsActive(e, binding) === false) return false;

  // Check if additional elements were passed to be included in check
  // (click must be outside all included elements, if any)
  const elements = (
    (typeof binding.value === 'object' && binding.value.include) ||
    (() => [])
  )();
  // Add the root element for the component this directive was defined on
  elements.push(el);

  // Check if it's a click outside our elements, and then if our callback returns true.
  // Non-toggleable components should take action in their callback and return falsy.
  // Toggleable can return true if it wants to deactivate.
  // Note that, because we're in the capture phase, this callback will occur before
  // the bubbling click event on any outside elements.
  return !elements.some(el => el.contains(e.target));
}

function checkIsActive(e, binding) {
  const isActive =
    (typeof binding.value === 'object' && binding.value.closeConditional) ||
    (() => true);

  return isActive(e);
}

function directive(e, el, binding, vnode) {
  const containsClick = !el._contextMenuOutside.lastMousedownWasOutside;

  if (containsClick || !checkEvent(e, el, binding)) return;

  const handler =
    typeof binding.value === 'function'
      ? binding.value
      : binding.value?.handler;

  if (!handler) {
    throw new Error('No handler provided!');
  }

  setTimeout(() => {
    handler && handler(e);
  }, 0);
}

function inserted(el, binding, vnode) {
  const onContextMenu = e => directive(e, el, binding, vnode);
  const onMouseDown = e => {
    // if (e.button !== 0) { // filter left clicks
    el._contextMenuOutside.lastMousedownWasOutside = checkEvent(e, el, binding);
    // }
  };

  document.body.addEventListener('contextmenu', onContextMenu, true);
  document.body.addEventListener('mousedown', onMouseDown, true);

  if (!el._contextMenuOutside) {
    el._contextMenuOutside = {
      lastMousedownWasOutside: true,
    };
  }

  // store reference to functions so they can be unbound later
  if (vnode.context && vnode?.context?._uid) {
    el._contextMenuOutside[vnode.context._uid] = {
      onContextMenu,
      onMouseDown,
    };
  }
}

function unbind(el, binding, vnode) {
  const { onContextMenu, onMouseDown } = el._contextMenuOutside[
    vnode.context._uid
  ];

  document.body.removeEventListener('contextmenu', onContextMenu, true);
  document.body.removeEventListener('mousedown', onMouseDown, true);
}

export const ContextOutside = {
  inserted,
  unbind,
};

export default ContextOutside;
